import { ValueOf } from '../../../utilities/types';

const resetMfaSteps = {
  PASSWORD: 'password',
  PAIR: 'pair',
  RECOVERY_CODES: 'recovery-codes',
} as const;

export type ResetMfaStep = ValueOf<typeof resetMfaSteps>;

export const deriveResetMfaStep = ({
  hasRecoveryCodes,
  hasPendingEnrollment,
}: {
  hasRecoveryCodes: boolean;
  hasPendingEnrollment: boolean;
}): ResetMfaStep => {
  if (hasRecoveryCodes) return resetMfaSteps.RECOVERY_CODES;
  if (hasPendingEnrollment) return resetMfaSteps.PAIR;
  return resetMfaSteps.PASSWORD;
};

export default resetMfaSteps;
